import { createAsyncThunk } from '@reduxjs/toolkit';
import { engineMeasurementApi } from '../../api/engineMeasurementApi';
import { EngineMeasurementRequest } from '../types/types';

export const getAllEngineMeasurements = createAsyncThunk(
  'engineMeasurement/getAll',
  async (_, { rejectWithValue }) => {
    try {
      const response = await engineMeasurementApi.getEngineMeasurements();
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const getEngineMeasurementById = createAsyncThunk(
  'engineMeasurement/getById',
  async (id: number, { rejectWithValue }) => {
    try {
      const response = await engineMeasurementApi.getEngineMeasurementById(id);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const createEngineMeasurement = createAsyncThunk(
  'engineMeasurement/create',
  async (data: EngineMeasurementRequest, { rejectWithValue }) => {
    try {
      const response = await engineMeasurementApi.createEngineMeasurement(data);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const updateEngineMeasurement = createAsyncThunk(
  'engineMeasurement/update',
  async ({ id, data }: { id: number; data: EngineMeasurementRequest }, { rejectWithValue }) => {
    try {
      const response = await engineMeasurementApi.updateEngineMeasurement(id, data);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const deleteEngineMeasurement = createAsyncThunk(
  'engineMeasurement/delete',
  async (id: number, { rejectWithValue }) => {
    try {
      await engineMeasurementApi.deleteEngineMeasurement(id);
      return id;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const getEngineMeasurementsByEngineId = createAsyncThunk(
  'engineMeasurement/getAllByEngineId',
  async (engineId: number, { rejectWithValue }) => {
    try {
      const response = await engineMeasurementApi.getEngineMeasurements(engineId);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);
